import type { SVGProps } from 'react'

/**
 * Ícones em SVG inline.
 *
 * Sem biblioteca de ícones: o conjunto que o CRM usa é fechado (menos de trinta
 * traços) e uma dependência de ícones custaria mais no pacote do que este arquivo
 * inteiro. `currentColor` em tudo, para o ícone herdar a cor do contexto e o tema
 * escuro funcionar sem variante.
 */

type Props = SVGProps<SVGSVGElement>

function Traco({ children, ...resto }: Props) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-5 w-5"
      {...resto}
    >
      {children}
    </svg>
  )
}

export const IconeMenu = (p: Props) => (
  <Traco {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Traco>
)

export const IconeInicio = (p: Props) => (
  <Traco {...p}>
    <path d="M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1v-8.5Z" />
  </Traco>
)

export const IconePainel = (p: Props) => (
  <Traco {...p}>
    <path d="M4 5h5v14H4zM10.5 5h5v9h-5zM17 5h3v6h-3z" />
  </Traco>
)

export const IconeLeads = (p: Props) => (
  <Traco {...p}>
    <path d="M16 19v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 17.5V19M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm10 8v-1.5a3.5 3.5 0 0 0-2.6-3.4M15.5 4.2a3.5 3.5 0 0 1 0 6.6" />
  </Traco>
)

export const IconeAgenda = (p: Props) => (
  <Traco {...p}>
    <path d="M5 6h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1ZM4 10h16M9 4v3m6-3v3" />
  </Traco>
)

export const IconeUsuario = (p: Props) => (
  <Traco {...p}>
    <path d="M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7 9v-1a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v1" />
  </Traco>
)

export const IconeConfiguracoes = (p: Props) => (
  <Traco {...p}>
    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2V21a2 2 0 1 1-4 0v-.1A1.7 1.7 0 0 0 7 19.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.7 1.7 0 0 0 3 13.6H3a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 4.7 7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.7 1.7 0 0 0 10.4 3V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0 1.2 2.9H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
  </Traco>
)

export const IconeSair = (p: Props) => (
  <Traco {...p}>
    <path d="M9 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3m7 4 4 4-4 4M20 12H10" />
  </Traco>
)

export const IconeSino = (p: Props) => (
  <Traco {...p}>
    <path d="M18 9a6 6 0 0 0-12 0c0 5-2 6-2 6h16s-2-1-2-6M13.7 20a2 2 0 0 1-3.4 0" />
  </Traco>
)

export const IconeSol = (p: Props) => (
  <Traco {...p}>
    <path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-13v2m0 14v2M4.2 4.2l1.5 1.5m12.6 12.6 1.5 1.5M3 12h2m14 0h2M4.2 19.8l1.5-1.5M18.3 5.7l1.5-1.5" />
  </Traco>
)

export const IconeLua = (p: Props) => (
  <Traco {...p}>
    <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" />
  </Traco>
)

export const IconeBusca = (p: Props) => (
  <Traco {...p}>
    <path d="M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5.5-1.5L21 21" />
  </Traco>
)

export const IconeFiltro = (p: Props) => (
  <Traco {...p}>
    <path d="M4 5h16l-6.5 8v6l-3-2v-4L4 5Z" />
  </Traco>
)

export const IconeMais = (p: Props) => (
  <Traco {...p}>
    <path d="M12 5v14M5 12h14" />
  </Traco>
)

export const IconeBaixar = (p: Props) => (
  <Traco {...p}>
    <path d="M12 4v11m0 0 4-4m-4 4-4-4M5 19h14" />
  </Traco>
)

export const IconeEnviar = (p: Props) => (
  <Traco {...p}>
    <path d="M12 20V9m0 0 4 4m-4-4-4 4M5 5h14" />
  </Traco>
)

export const IconeVoltar = (p: Props) => (
  <Traco {...p}>
    <path d="M10 6 4 12l6 6M4 12h16" />
  </Traco>
)

export const IconeSeta = (p: Props) => (
  <Traco {...p}>
    <path d="m9 6 6 6-6 6" />
  </Traco>
)

export const IconeWhatsapp = (p: Props) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="h-5 w-5"
    {...p}
  >
    <path d="M12.04 2C6.6 2 2.2 6.4 2.2 11.84c0 1.9.53 3.68 1.46 5.2L2 22l5.1-1.63a9.8 9.8 0 0 0 4.94 1.33h.01c5.43 0 9.84-4.4 9.84-9.84C21.89 6.4 17.48 2 12.04 2Zm5.75 13.9c-.24.68-1.4 1.3-1.93 1.35-.53.05-1.02.24-3.44-.71-2.9-1.15-4.73-4.16-4.87-4.36-.15-.2-1.16-1.57-1.16-3 0-1.42.75-2.12 1.02-2.41.26-.29.57-.36.76-.36l.55.01c.17 0 .41-.07.63.48.24.58.8 1.99.87 2.13.07.15.12.32.02.51-.1.2-.15.32-.29.5-.15.17-.31.38-.44.51-.15.14-.3.3-.13.6.17.29.75 1.24 1.61 2 1.11.99 2.04 1.3 2.33 1.44.29.15.46.13.63-.08.17-.2.73-.85.92-1.14.2-.29.39-.24.66-.15.26.1 1.67.79 1.96.93.29.15.48.22.55.34.07.13.07.75-.17 1.43Z" />
  </svg>
)

export const IconeTelefone = (p: Props) => (
  <Traco {...p}>
    <path d="M6.5 4h3l1.5 4-2 1.5a11 11 0 0 0 5.5 5.5L16 13l4 1.5v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4 6.2 2 2 0 0 1 6 4Z" />
  </Traco>
)

export const IconeEmail = (p: Props) => (
  <Traco {...p}>
    <path d="M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm0 1 8 6 8-6" />
  </Traco>
)

export const IconeEditar = (p: Props) => (
  <Traco {...p}>
    <path d="M4 20h4l10-10a2.8 2.8 0 0 0-4-4L4 16v4Zm10-14 4 4" />
  </Traco>
)

export const IconeRelogio = (p: Props) => (
  <Traco {...p}>
    <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13v5l3.5 2" />
  </Traco>
)

export const IconeCheck = (p: Props) => (
  <Traco {...p}>
    <path d="m5 13 4.5 4.5L19 7" />
  </Traco>
)

export const IconeX = (p: Props) => (
  <Traco {...p}>
    <path d="M6 6l12 12M18 6 6 18" />
  </Traco>
)

export const IconeTransferir = (p: Props) => (
  <Traco {...p}>
    <path d="M4 8h13m0 0-3-3m3 3-3 3M20 16H7m0 0 3-3m-3 3 3 3" />
  </Traco>
)

export const IconeGrafico = (p: Props) => (
  <Traco {...p}>
    <path d="M4 20V6m0 14h16M8 20v-6m4 6V9m4 11v-4" />
  </Traco>
)

export const IconePredio = (p: Props) => (
  <Traco {...p}>
    <path d="M6 21V5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v16M15 10h3a1 1 0 0 1 1 1v10M4 21h16M9 8h3M9 12h3M9 16h3" />
  </Traco>
)

export const IconeEtiqueta = (p: Props) => (
  <Traco {...p}>
    <path d="M12.6 4H19a1 1 0 0 1 1 1v6.4a1 1 0 0 1-.3.7l-7.6 7.6a1 1 0 0 1-1.4 0l-6.4-6.4a1 1 0 0 1 0-1.4l7.6-7.6a1 1 0 0 1 .7-.3Zm3.9 4.5h.01" />
  </Traco>
)

export const IconeArquivo = (p: Props) => (
  <Traco {...p}>
    <path d="M13 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8l-5-5Zm0 0v5h5" />
  </Traco>
)

export const IconeAtualizar = (p: Props) => (
  <Traco {...p}>
    <path d="M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6" />
  </Traco>
)

export const IconeAlerta = (p: Props) => (
  <Traco {...p}>
    <path d="M12 9v4m0 3h.01M10.3 4.9 2.6 18.2A1.9 1.9 0 0 0 4.3 21h15.4a1.9 1.9 0 0 0 1.7-2.8L13.7 4.9a1.9 1.9 0 0 0-3.4 0Z" />
  </Traco>
)

export const IconeCadeado = (p: Props) => (
  <Traco {...p}>
    <path d="M7 11V8a5 5 0 0 1 10 0v3M6 11h12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1Z" />
  </Traco>
)

// --- Meta Ads (agente 24) --------------------------------------------------

/** Megafone — mídia paga. Item de menu do Command Center. */
export const IconeMegafone = (p: Props) => (
  <Traco {...p}>
    <path d="M3 11v2a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1Zm12.5-3.5a5 5 0 0 1 0 9M18 5a8.5 8.5 0 0 1 0 14" />
  </Traco>
)

/** Tendência de alta. */
export const IconeSubindo = (p: Props) => (
  <Traco {...p}>
    <path d="M3 17l6-6 4 4 8-8m0 0h-6m6 0v6" />
  </Traco>
)

/** Tendência de queda. */
export const IconeCaindo = (p: Props) => (
  <Traco {...p}>
    <path d="M3 7l6 6 4-4 8 8m0 0h-6m6 0v-6" />
  </Traco>
)

/** Estável — a faixa morta da tendência. */
export const IconeEstavel = (p: Props) => (
  <Traco {...p}>
    <path d="M4 12h16" />
  </Traco>
)

/** Faísca — insight ou sugestão da IA. */
export const IconeFaisca = (p: Props) => (
  <Traco {...p}>
    <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Zm7 9.5.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9.9-2.1Z" />
  </Traco>
)

/** Pausar — a ação do §11. */
export const IconePausar = (p: Props) => (
  <Traco {...p}>
    <path d="M9 5v14M15 5v14" />
  </Traco>
)
